import { Box } from "@mui/material";
import { ITkInfoManualProps } from "../../../type/componentsType/TkInfoManual";
import { useEffect, useState } from "react";
import "./_style.scss";

/**
 * splitTextAtPeriods関数は、句点で区切られたテキストを改行で区切る関数です。
 * @param {string} text - 区切る前のテキスト
 * @returns {string} 改行で区切られたテキスト
 */
const splitTextAtPeriods = (
  text: string,
  rule: string | undefined
): string[] => {
  if (!text || !rule) return [text];

  const sentences = text.split(rule);
  return sentences;
};

/**
 * 説明用ラベル部品
 * テキストエリアを表示し、ユーザーが入力したテキストを句点で分割して改行する機能を提供します。
 * @param {Object} props - Reactコンポーネントのprops
 * @param {string} props.child - テキストエリアに表示する初期テキスト
 * @returns TkInfoManual 説明用ラベル部品
 */
const TkInfoManual = ({ children, rule, className }: ITkInfoManualProps): JSX.Element => {
  const [text, setText] = useState<string[]>([]);

  /**
   * handleText関数は、テキストエリアの値が変更されたときに呼び出され、
   * 入力されたテキストを句点で分割して改行します。
   * @param {Object} event - Reactのイベントオブジェクト
   * @param {string} event.target.value - テキストエリアの値
   * @param {string | undefined} rule - ルールの文字列
   * @returns {void}
   */
  const handleText = (event: string, rule: string | undefined): void => {
    const newText = splitTextAtPeriods(event, rule);
    setText(newText);
  };

  useEffect(() => {
    handleText(children, rule);
  }, [children, rule]);

  /**
   * TkInfoManualコンポーネントは、テキストを句点で分割して改行するためのコンポーネントです。
   * @param {Object} props - Reactのプロパティオブジェクト
   * @param {string} props.children - テキストエリアの値
   * @param {string | undefined} props.rule - ルールの文字列
   * @returns {JSX.Element}
   */
  return (
    <Box className={`tkInfoBox ${className}`}>
      {text.map((item, index) => {
        return (
          <Box key={index} className="tkInfoText">
            {item}
          </Box>
        );
      })}
    </Box>
  );
};

export default TkInfoManual;
